

function getPopupHTML() {
  return `
    <div class="popup-inner">
      <div class="product-name">
        <h2>Ihre Gerichte</h2>
        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/qty-cart.svg?v=1767698038" alt="qty cart" />
        <button class="mobile-cart-detail visible-mobile" id="mobile-cart">
          <svg xmlns="http://www.w3.org/2000/svg" width="23.658" height="13.999" viewBox="0 0 23.658 13.999">
            <g id="drop_down" data-name="drop down" transform="translate(21.537 11.877) rotate(180)">
              <line id="Line_5" data-name="Line 5" y1="9.756" x2="9.459" transform="translate(0 0)" fill="none" stroke="#e19f8f" stroke-linecap="round" stroke-width="3"/>
              <line id="Line_6" data-name="Line 6" x1="9.737" y1="9.756" transform="translate(9.679 0)" fill="none" stroke="#e19f8f" stroke-linecap="round" stroke-width="3"/>
            </g>
          </svg>
          <span>Details siehe</span>
        </button>
      </div>
      <div class="popup-mobile-info-cta">
        <span>Ausgewählte Portionen</span>
        <span>0</span>
      </div>
      <div class="popup-mobile-wrapper">
        <div class="popup-product-info">
          <div class="info-popup-trigger">Hilfe zur Portionenanzahl <span>?</span></div>
          <div class="model-product-info">
            <div class="model-product-info-block">
              <button class="drawer-modal-close">
                <svg xmlns="http://www.w3.org/2000/svg" width="46.866" height="47.957" viewBox="0 0 46.866 47.957">
                  <g id="Group_1226" data-name="Group 1226" transform="translate(-1611.694 -741.608)">
                    <g id="Component_5_7" data-name="Component 5 – 7" transform="translate(1614.521 744.437)">
                      <g id="drop_down" data-name="drop down">
                        <line id="Line_5" data-name="Line 5" x2="20.077" y2="21.15" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6" data-name="Line 6" x1="20.667" y2="21.15" transform="translate(20.543)" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </g>
                    <g id="Component_5_8" data-name="Component 5 – 8" transform="translate(1614.521 765.587)">
                      <g id="drop_down-2" data-name="drop down">
                        <line id="Line_5-2" data-name="Line 5" y1="21.15" x2="20.077" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                        <line id="Line_6-2" data-name="Line 6" x1="20.667" y1="21.15" transform="translate(20.543)" fill="none" stroke="#35437C" stroke-linecap="round" stroke-width="4"/>
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
              <div class="product-info-content">
                <h2 class="popup-title">Portionenanzahl</h2>
                <div class="item-cart">
                  <div class="item-img">
                    <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/product-item.png?v=1767778087" alt="item" />
                  </div>
                  <div class="item-content">
                    <div class="product-cart-item">
                      <span class="qty">1X</span> Chinuki Portion* = <span class="total">280g</span>
                    </div>
                  </div>       
                </div>                 
                <div class="protine-info protine-box">
                  <h4>Empfohlene Portionsgrößen</h4>
                  <p>(laut DGE für die warme Mittagsmahlzeit)</p>
                  <div class="protine-list">
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>unter 3 Jahre</div>
                      </div>
                      <p class="protine-count">~150-200g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>3-6 Jahre</div>
                      </div>
                      <p class="protine-count">~200-250g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age">U3</span>Schulkinder</div>
                      </div>
                      <p class="protine-count">~250-300g</p>
                    </div>  
                    <div class="protine-items">
                      <div class="item-image">
                        <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/protine-item.png?v=1767778403" alt="item" />
                      </div>
                      <div class="item-image-info">
                        <div class="suggest-age"><span class="age blank"></span>Erwachsener</div>
                      </div>
                      <p class="protine-count">~400-500g</p>
                    </div>  
                  </div>
                </div>
                <div class="protine-pending protine-box">
                  <h4>Kalkulationsbeispiel</h4>
                  <div class="protine-pending-list">
                    <div class="protine-pending-image">
                      <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/pending-protine.png?v=1767778849" alt="pending protine" />
                    </div>
                    <div class="protine-pending-data">
                      <div class="pending-data-list">
                        <div class="data-count"><p>Kind <span class="suggest-age-pending">U3</span></p></div>
                        <div class="data-pending"><p>~170g</p></div>
                      </div>
                      <div class="pending-data-list">
                        <div class="data-count"><p>Kind <span class="suggest-age-pending">U6</span></p></div>
                        <div class="data-pending"><p>~270g</p></div>
                      </div>
                      <div class="pending-data-list">
                        <div class="data-count"><p>Erwachsener</p></div>
                        <div class="data-pending"><p>~400g</p></div>
                      </div>
                      <div class="pending-data-list total">
                        <div class="data-count"><p>Summe Portionen</p></div>
                        <div class="data-pending"><p>~840g</p></div>
                      </div>
                    </div>
                  </div>
                  <div class="best-buy">
                    <div class="protine-pending-image">
                      <img src="https://cdn.shopify.com/s/files/1/0681/2804/7414/files/pending-protine.png?v=1767778849" alt="pending protine" />
                    </div>
                    <div class="protine-pending-data">
                      <p>Bestellmenge pro Gericht*</p>
                      <div class="total-protine">
                        <span class="pending-qty">3x</span><span class="pending-price"> 280g</span> = <span class="pending-totel">840g</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="note">
                  <p>* Mindestportionanzahl pro Gericht: 3x Portionen</p>
                </div>
                <div class="protine-cta">
                  <button class="protine-button">Bestätigen</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="product-cart-wrapper"></div> 
      </div>
      <div class="product-popup-summary">
        <div class="cart-process">
          <p class="process-pending-count"></p>
          <div class="cart-process-bar">
            <div class="min-order process-bar">
              <label>Mindestbestellmenge</label>
              <div class="progress">
                <div class="act-process"></div>
              </div>
            </div>
            <div class="free-shipping process-bar">
              <label>5€ Versandkostennachlass</label>
              <div class="progress">
                <div class="act-process"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="cart-item-info">
          <div class="total-number">
            <p>Gesamte Portionenanzahl</p>
            <p class="total-number-count total-portion-count"></p>
          </div>
          <div class="total-number total-number-qty">
            <p>Gesamtgewicht</p>
            <p class="total-number-count total-weight"></p>
          </div>
          <div class="total-price-info total-price-sub">
            <p>Zwischensumme</p>
            <p class="total-price"></p>
          </div>
          <div class="total-price-info shipping-cost">
            <p>Versandkosten</p>
            <p class="total-price">€ <span>0,00</span></p>
          </div>
          <p class="shipping-note">Glückwunsch! 5€ Versandrabatt erhalten.</p>
          <div class="total-price-info final-price">
            <p>Gesamt</p>
            <p class="total-price">€ <span class="calculated-price">0,00</span></p>
          </div>
          <div class="total-price-info vat">
            <p>inkl. 7% MwSt.</p>
            <p class="total-price">€ <span class="tax-price">0,00</span></p>
          </div>
        </div>
        <div class="atc-btn-block">
          <button class="atc-btn">Bestellen</button>
        </div>
      </div>
    </div>
  `;
}


  // Accordion
  document.addEventListener('click', e => {
    const header = e.target.closest('.accordion-header');
    if (!header) return;

    const currentItem = header.parentElement;
    document.querySelectorAll('.accordion-item').forEach(item => {
      if (item !== currentItem) item.classList.remove('active');
    });
    currentItem.classList.toggle('active');
  });

  // Info popup
  document.addEventListener('click', e => {
    const popupTrigger = e.target.closest('.info-popup-trigger');
    const closeModal = e.target.closest('.drawer-modal-close');

    if (popupTrigger) {
      const popupModal = popupTrigger.closest('.popup-product-info').querySelector('.model-product-info');
      popupModal.classList.add('active');
    }

    if (closeModal) {
      const popupModal = closeModal.closest('.model-product-info');
      popupModal.classList.remove('active');
    }
  });

  document.addEventListener('click', e => {
    const infoConfirmBtn = e.target.closest('.protine-button');
    if (!infoConfirmBtn) return;
    const popup = infoConfirmBtn.closest('.model-product-info.active');
    if (!popup) return;
    popup.classList.remove('active');
  })

  // Click handler for device buttons start
  document.addEventListener('click', e => {
    const btn = e.target.closest('.sources-btn');
    if (!btn) return;

    const container = btn.closest('.device-sources');
    if (!container) return;

    const deviceBtns = document.querySelectorAll('.sources-btn');
    deviceBtns.forEach(b => {
      b.classList.remove('selected');
      b.style.backgroundColor = '';
      b.style.color = '';
    });

    const popupId = btn.getAttribute('data-popup');

    if (popupId === 'with-device') {
      const popup = container.querySelector(`#${popupId}`);
      if (!popup) return;

      popup.classList.add('active');

      const confirmBtn = popup.querySelector('.device-button');

      const confirmHandler = async () => {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
          const cart = await res.json();

          if (cart.items.length > 0) {
            btn.classList.add('selected');
            btn.style.backgroundColor = '#35437c';
            btn.style.color = '#fff';
          }
        } catch (error) {
          console.error('Failed to confirm device selection:', error);
        } finally {
          confirmBtn.removeEventListener('click', confirmHandler);
          popup.classList.remove('active');
        }
      };

      confirmBtn.addEventListener('click', confirmHandler);
    }

    if (popupId === 'without-device') {
      (async () => {
        try {
          const res = await fetch('/cart.js');
          if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);
          const cart = await res.json();

          if (cart.items.length > 0) {
            btn.classList.add('selected');
            btn.style.backgroundColor = '#35437c';
            btn.style.color = '#fff';
          }
        } catch (error) {
          console.error('Failed to select without device:', error);
        } finally {
          container.querySelector(`#${popupId}`)?.classList.remove('active');
        }
      })();
    }
  });

  // Close popup
  document.addEventListener('click', e => {
    const closePopupModal = e.target.closest('.device-popup-close');
    if (!closePopupModal) return;
    const popup = closePopupModal.closest('.device-popup.active');
    if (!popup) return;
    popup.classList.remove('active');
  })


  // Mobile info CTA
  document.addEventListener('click', e => {
    const mobileInfoCTA = e.target.closest('.popup-mobile-info-cta');
    if (!mobileInfoCTA) return;

    document.body.classList.add('mobile-detail-popup-open');
  });

  // Mobile cart toggle
  document.addEventListener('click', e => {
    const mobileCartBtn = e.target.closest('#mobile-cart');
    if (!mobileCartBtn) return;

    // Toggle the class on body
    document.body.classList.toggle('mobile-detail-popup-open');
    const span = mobileCartBtn.querySelector('span');
    if (!span) return;

    if (document.body.classList.contains('mobile-detail-popup-open')) {
      span.textContent = 'Details verbergen';
    } else {
      span.textContent = 'Details siehe';
    }
  });


function applyMatchHeight() {
  // Target the dish titles inside the currently visible / all product cards
  $('.home-collection .product-card .product-content .dish-title').matchHeight({
    byRow: true
  });
}
  // ------------- Product detail popup modal functionality starts -----------------//
  document.addEventListener('click', async function (e) {
    const modal = document.getElementById('productModal');
    const modalContent = modal.querySelector('.custom-modal-row');
    const detailBtn = e.target.closest('.product-detail-trigger');
    const productImage = e.target.closest('.product-image');
    const modalCartBtn = e.target.closest('.js-modal-add-to-cart');

    const isDesktop = window.matchMedia('(min-width: 992px)').matches;
    const isMobile = !isDesktop;

    if ((isDesktop && detailBtn) || (isMobile && productImage)) {
      const triggerEl = detailBtn || productImage;
      const productHandle = triggerEl.getAttribute('data-product-handle');
      const productWeight = triggerEl.getAttribute('data-product-weight');
      const dishColor = triggerEl.getAttribute('data-dish-color');
      modalContent.innerHTML = '';

      try {
        if (detailBtn) {
          detailBtn.classList.add('loading');
          detailBtn.disabled = true; 
        }
        // Fetch product JSON
        const productRes = await fetch(`/products/${productHandle}.js`);
        const productData = await productRes.json();

        const response = await fetch(`/products/${productHandle}?view=b2c-product-detail`);
        const html = await response.text();

        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        const detailContainer = tempDiv.querySelector('.custom-modal-row');

        if (detailContainer) {
          modalContent.innerHTML = detailContainer.innerHTML;
          modalContent.setAttribute('data-variant-id',productData.variants[0].id);
          modalContent.setAttribute('data-product-weight',productWeight);
          modalContent.setAttribute('data-dish-color',dishColor);

          const modalImages = modalContent.querySelectorAll('img');
          modalImages.forEach(img => {
            img.loading = 'eager';
            img.onload = () => {
              img.classList.add('loaded');
            };
          });
        }

        if($('.modal-content-block').find('.jdgm-prev-badge__text').length){
          let reviewString = $('.modal-content-block').find('.jdgm-prev-badge__text').text();        
          reviewString = reviewString.split(" ")[1]
          if(reviewString.includes("No")){
            var str2_desktop = 'Keine Bewertungen'
          }else{
            var str2_desktop = reviewString +' Bewertungen'
          }                
          $('.modal-content-block').find('.jdgm-prev-badge__text').text(str2_desktop)
        }

        var reciew_button_url = '/products/'+productHandle+'?review-open-form'
        setTimeout(function() {
          $("#productModal .custom-modal-content .jdgm-preview-badge").wrap('<a href="'+ reciew_button_url +'"></a>');
          $('.product-detail__valuation').each(function() {
            $(this).html(
              '<a href="'+ reciew_button_url +'" class="btn btn--quaternary btn--small">Jetzt bewerten</a>'
            );
          });
        },200);

        // const activeTabContent = document.querySelector('.tab-content.active');
        // const isPastDelivery = activeTabContent?.classList.contains('past-delivery');

        setTimeout(() => {
          const modalAddBtn = modal.querySelector('.js-modal-add-to-cart');

          modal.style.display = 'flex';
          document.body.style.overflow = 'hidden';

            // modalAddBtn.style.opacity = '1';
            // modalAddBtn.disabled = false;
            // modalAddBtn.style.cursor = 'pointer';

        }, 200)

      } catch (error) {
        console.error('Failed to fetch product!', error);
      } finally {
        if (detailBtn) {
          detailBtn.classList.remove('loading');
          detailBtn.disabled = false;
        }
      }
      return;
    }

    if (modalCartBtn) {
      const variantId = document.querySelector('.custom-modal-row').getAttribute('data-variant-id');
      const productWeight = document.querySelector('.custom-modal-row').getAttribute('data-product-weight');
      const dishColor = document.querySelector('.custom-modal-row').getAttribute('data-dish-color');
      if (!variantId) return;
      try {
        // const currentTab = document.querySelector('.tab.active');
        // const deliveryDate = currentTab.dataset.deliveryDate;

        modalCartBtn.classList.add('loading'); 
        modalCartBtn.disabled = true;

        await addToCart(variantId, 3, "", productWeight, dishColor);


        document.body.classList.add('show-ingredient');
        modal.style.display = 'none';
        document.body.style.overflow = 'auto';

      } catch (error) {
        console.error('Add to cart failed:', error);
      } finally {
        modalCartBtn.classList.remove('loading');
        modalCartBtn.disabled = false;
      }

      return;
    }

    if (e.target.closest('.custom-modal-close') || e.target.classList.contains('modal-overlay') || e.target.closest('.js-modal-back')) {
      modal.style.display = 'none';
      document.body.style.overflow = 'auto';
    }
  });
  // ------------- Product detail popup modal functionality ends -----------------//

async function addToCart(variantId, quantity = 3, deliveryDate, productWeight, dishcolor) {
  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ 
        id: variantId, 
        quantity,
        properties: {
          // 'unique_item': String(Date.now()),
          '_delivery_date': deliveryDate,
          '_product_weight': productWeight,
          '_dish_color': dishcolor
        }
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.description || 'Failed to add to cart');
    }

    updateCartUI();

  } catch (error) {
    console.error('Error adding product to cart:', error);
  }
}

async function updateCartUI() {
  try {
    const activeTabContent = document.querySelector('.tab-content.active');
    const progressPending = activeTabContent.querySelector('.process-pending-count');
    const BAR_LIMIT = 12;
    const SHIPPING_LIMIT = BAR_LIMIT * 2;
    const minOrderProgress = activeTabContent.querySelector('.min-order .act-process');
    const freeShippingProgress = activeTabContent.querySelector('.free-shipping .act-process');
    const DISCOUNT = 5; // 5€ discount for orders above SHIPPING_LIMIT

    const res = await fetch('/cart.js');
    const cart = await res.json();

    const cartWrapper = activeTabContent.querySelector('.product-cart-wrapper');
    cartWrapper.innerHTML = ''; // Clear existing items
    let totalPortions = 0;

    const cartVariantIds = new Set(
      cart.items.map(item => String(item.variant_id))
    );
    activeTabContent.querySelectorAll('.product-cta').forEach(cta => {
      const variantId = cta.dataset.variantId;
      if (cartVariantIds.has(String(variantId))) {
        cta.classList.add('active');
      } else {
        cta.classList.remove('active');
      }
    });


    cart.items.forEach(item => {
      totalPortions += item.quantity;
      const productWeight = item.properties?._product_weight;
      const dishColor = item.properties?._dish_color;
      // Append each item to cart UI
      cartWrapper.innerHTML += `
        <div class="cart-items" data-line="${item.key}" data-product-id="${item.product_id}" data-variant-id="${item.variant_id}" data-product-handle="${item.handle}" data-product-title="${item.title}">
          <div class="cart-image-wrapper" style="--bg-color: ${dishColor};">
            <div class="cart-items-image">
              <img src="${item.image}" alt="${item.title}" />
            </div>
          </div>
          <div class="cart-qty-box">            
            <div class="qty-box">
              <div class="quantity-selector-wrapper">
                <div class="cart-tag-wrapper">
                  <p class="cart-tag">Portionenanzahl</p>
                </div>
                <div class="quantity-selector">
                  <button class="qty-minus" data-action="decrease" data-line="${item.key}" style="${item.quantity <= 3 ? 'pointer-events:none;opacity:0.4;' : ''}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="2" viewBox="0 0 20 2">
                      <line y2="20" transform="translate(20 1) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"></line>
                    </svg>
                  </button>
                  <div class="qty-txt">
                    <input type="text" name="cart-qty" value="${item.quantity}" />
                  </div>
                  <button class="qty-plus" data-action="increase" data-line="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
                      <g transform="translate(-1040.5 -1890.5)">
                        <line y2="20" transform="translate(1050.5 1890.5)" fill="none" stroke="#35437c" stroke-width="2"></line>
                        <line y2="20" transform="translate(1060.5 1900.5) rotate(90)" fill="none" stroke="#35437c" stroke-width="2"></line>
                      </g>
                    </svg>
                  </button>
                  <button class="remove-btn" data-line="${item.key}">
                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="100" height="100" viewBox="0 0 16 16">
                      <path d="M 6.496094 1 C 5.675781 1 5 1.675781 5 2.496094 L 5 3 L 2 3 L 2 4 L 3 4 L 3 12.5 C 3 13.324219 3.675781 14 4.5 14 L 10.5 14 C 11.324219 14 12 13.324219 12 12.5 L 12 4 L 13 4 L 13 3 L 10 3 L 10 2.496094 C 10 1.675781 9.324219 1 8.503906 1 Z M 6.496094 2 L 8.503906 2 C 8.785156 2 9 2.214844 9 2.496094 L 9 3 L 6 3 L 6 2.496094 C 6 2.214844 6.214844 2 6.496094 2 Z M 4 4 L 11 4 L 11 12.5 C 11 12.78125 10.78125 13 10.5 13 L 4.5 13 C 4.21875 13 4 12.78125 4 12.5 Z M 5 5 L 5 12 L 6 12 L 6 5 Z M 7 5 L 7 12 L 8 12 L 8 5 Z M 9 5 L 9 12 L 10 12 L 10 5 Z"></path>
                    </svg>
                  </button>
                </div>
              </div>              
            </div>
            <div class="cart-qty">
              <div class="signle-qty-cal">
                <span class="qty">${item.quantity} x</span>
                <span class="product-weight cal">${productWeight}</span>
              </div>
              <div class="totle-qty-cal">
                <span class="totle-cal cal">${parseFloat(productWeight) * item.quantity}g</span>
              </div>
            </div>
            <div class="cart-qty">
              <div class="signle-qty-cal">
                <span class="qty">${item.quantity} x</span>
                <span class="cart-item__price cal" data-product-price="${(item.price / 100).toFixed(2)}">€ ${(item.price / 100).toFixed(2).replace('.', ',')}</span>
              </div>
              <div class="totle-qty-cal">
                <span class="totle-cal cal price">€${(item.line_price / 100).toFixed(2).replace('.', ',')}</span>
              </div>
            </div>
          </div>
          <p class="cart-product-name">${item.title}</p>
        </div>
      `;
    });

    // Update cart count bubble
    const cartCountWrapper = document.querySelector('.cart-count-wrapper');
    const cartCountEl = document.querySelector('.b2c-cart-count .cart-item-count');
    if (cartCountEl) {
      cartCountEl.textContent = cart.item_count;

      if (cart.item_count > 0) {
        cartCountWrapper.classList.add('active');
      } else {
        cartCountWrapper.classList.remove('active');
      }
    }

    // Update total number of servings
    const totalNumberOfServings = activeTabContent.querySelector('.total-portion-count');
    totalNumberOfServings.textContent = totalPortions;  

    // Update total weight 
    const totalWeightEl = activeTabContent.querySelector('.total-weight');
    const totalWeight = cart.items.reduce((acc, item) => {
      const productWeight = parseFloat(item.properties?._product_weight) || 0;
      return acc + (productWeight * item.quantity);
    }, 0);
    totalWeightEl.textContent = totalWeight + 'g';

    // Update total price
    const totalPriceEl = activeTabContent.querySelector('.total-price-info .total-price');
    if (totalPriceEl) {
      totalPriceEl.textContent = '€ ' + (cart.total_price / 100).toFixed(2).replace('.', ',');
    }

    // Update Shipping Cost based on number of portions
    const shippingEl = activeTabContent.querySelector('.shipping-cost span');
    let shippingCost = 0;
    if (totalPortions >= 1 && totalPortions <= 50) {
      shippingCost = 10.59;
    } else if (totalPortions >= 51 && totalPortions <= 100) {
      shippingCost = 17.52;
    } else if (totalPortions >= 101 && totalPortions <= 125) {
      shippingCost = 24.90;
    }

    if (totalPortions >= 24) {
      shippingCost = Math.max(0, shippingCost - DISCOUNT);
    }

    shippingEl.textContent = shippingCost.toFixed(2).replace('.', ','); 
    // Update Calculated Price
    const calculatedPriceEl = activeTabContent.querySelector('.total-price-info .calculated-price');
    const calculatedPrice = (cart.total_price / 100) + shippingCost;
    calculatedPriceEl.textContent = calculatedPrice.toFixed(2).replace('.', ',');


    // Update VAT Tax
    const taxEl = activeTabContent.querySelector('.total-price-info.vat .tax-price');
    const vatAmount = calculatedPrice * 0.07;
    taxEl.textContent = vatAmount.toFixed(2).replace('.', ',');

    // Update Progress bar logic
    const firstBarFill = Math.min(totalPortions, BAR_LIMIT);
    const firstBarPercent = (firstBarFill / BAR_LIMIT) * 100;

    const secondBarFill = Math.max(totalPortions - BAR_LIMIT, 0);
    const secondBarPercent = Math.min((secondBarFill / BAR_LIMIT) * 100, 100);

    minOrderProgress.style.width = `${firstBarPercent}%`;
    freeShippingProgress.style.width = `${secondBarPercent}%`;

    // Pending count text (how many to reach 12)
    portionRemaining = Math.max(BAR_LIMIT - totalPortions, 0)
    if (totalPortions < BAR_LIMIT) {
      progressPending.textContent = `Noch ${portionRemaining} Portionen bis zur Mindestbestellmenge`;
    } else if (totalPortions === BAR_LIMIT) {
      progressPending.textContent = 'Mindestbestellmenge erreicht!';
    } else {
      const portionsToFreeShipping = SHIPPING_LIMIT - totalPortions;
      if (portionsToFreeShipping > 0) {
        progressPending.textContent = `Sie sind nur noch ${portionsToFreeShipping} Portionen von der kostenlosen Lieferung entfernt.`;
      } else {
        progressPending.textContent = 'Gratis Versand erreicht!';
      }
    }

    // Enable or disable ATC button based on minimum order
    const actBtn = activeTabContent.querySelector('.atc-btn');
    actBtn?.classList.toggle('active', totalPortions >= BAR_LIMIT);

    // Free shipping when 24 portions reached
    document.body.classList.toggle('free-shipping-active', totalPortions > BAR_LIMIT * 2);

    // reinitialize carousel if cart item count empty
    if (cart.items.length === 0) {
      const carousel = document.querySelector('.carousel');
      const activeTab = document.querySelector('.tab.active');
      const tabIndex = activeTab?.dataset.tab;

      if (carousel?.flickityInstance) {
        carousel.flickityInstance.destroy();
        carousel.flickityInstance = null;
      }

      carousel?.classList.remove('no-slider');
      initCarousel(carousel, tabIndex);

    }

    activeTabContent.querySelectorAll('.product-cta.active').forEach(cta => {
      const variantId = cta.dataset.variantId;
      const cartItem = cart.items.find(item => String(item.variant_id) === String(variantId));
      if (cartItem) {
        const minusBtn = cta.querySelector('.button-minus');
        if (minusBtn) {
          if (cartItem.quantity <= 3) {
            minusBtn.style.pointerEvents = 'none';
            minusBtn.style.opacity = '0.4';
          } else {
            minusBtn.style.pointerEvents = 'auto';
            minusBtn.style.opacity = '1';
          }
        }
      }
    });

    // // Updating mobile info cta 
    const mobileInfoCTA = activeTabContent.querySelectorAll('.popup-mobile-info-cta span');
    if(mobileInfoCTA.length > 1) mobileInfoCTA[1].textContent = cart.item_count;
  }catch(error) {
    console.error('Error updating cart UI:', error);
  }
}

async function clearCart() {
  try {
    const response = await fetch('/cart/clear.js', {
      method: 'POST'
    });

    if (!response.ok) {
      throw new Error('Failed to clear cart');
    }

    updateCartUI();
  } catch (error) {
    console.error(error);
  }
}

// Change cart item quantity
async function changeCartItemQuantity(line, quantity) {
  try {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity })
    });

    await updateCartUI();
  } catch (error) {
    console.error('Error updating cart quantity:', error);
  }
}

// ====================== Header Icon redirect to dish picker section & open cart  ======================
document.addEventListener('click', async function (e) {
  const cartIconLink = e.target.closest('a[href="#dish-picker"]');
  if (!cartIconLink) return;

  const loginPopup = cartIconLink.closest('.b2c-login-popup');

  e.preventDefault();

  if (loginPopup) {
    loginPopup.classList.remove('popup-is-open');
    loginPopup.style.display = 'none';
  }

  const dishPickerSection = document.getElementById('dish-picker');
  if (dishPickerSection) {
    dishPickerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
    });
  }

  setTimeout(async () => {
    const activeContent = document.querySelector('.tab-content.active');
    console.log('Active content:', activeContent);
    if (!activeContent) return;
    const carousel = activeContent.querySelector('.carousel');
    if (!carousel) return;
    if (carousel.classList.contains('no-slider')) return;

    if (carousel?.flickityInstance) {
      carousel.dataset.restoreIndex = carousel.flickityInstance.selectedIndex;
      carousel.flickityInstance.destroy();
      carousel.flickityInstance = null;
    }
    activeContent.querySelector('.tab-cta')?.classList.add('hidden');
    carousel?.classList.add('no-slider');
    document.body.classList.add('show-ingredient');
  }, 200);
});

document.addEventListener('click', async (e) => {
  const orderBtn = e.target.closest('.atc-btn.active');
  if (!orderBtn) return;

  try {
    const res = await fetch('/cart.js');
    if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status}`);

    const cartData = await res.json();

    const items = cartData.items.map(item => {
      const rawWeight = item.properties?._product_weight || '0g';

      // Remove 'g' and convert to number
      const baseWeight = parseFloat(rawWeight.replace('g', '').trim()) || 0;

      return {
        quantity: item.quantity,
        price: item.price,
        variant_id: item.variant_id,
        title: item.title,
        line_price: item.line_price,
        sku: item.sku,
        product_id: item.product_id,
        product_weight: baseWeight * item.quantity + 'g'
      };
    });

    console.log(items);

    const activeTabContent = document.querySelector('.tab-content.active');
    const totalPOrtionsEl = activeTabContent.querySelector('.total-portion-count');
    const totalPortions = parseInt(totalPOrtionsEl.textContent, 10);

    const shippingEl = activeTabContent.querySelector('.shipping-cost span');
    const shippingCost = parseFloat(shippingEl.textContent.replace(',', '.'));

    const calculatedPriceEl = activeTabContent.querySelector('.total-price-info .calculated-price');
    const calculatedPrice = parseFloat(calculatedPriceEl.textContent.replace('€', '').replace(',', '.'));
    const net_amount = calculatedPrice;
    const vatAmount = net_amount * 0.07;

    const deviceBtn = document.querySelector('.sources-btn.selected');
    const deviceValue = deviceBtn ? deviceBtn.getAttribute('data-popup') : null;

    const deliveryDate = document.querySelector('.tab.active').dataset.deliveryDate;

    const payload = {
      items,
      shipping_cost: shippingCost,
      vat_amount: vatAmount,
      gross_total: net_amount + vatAmount,
      total_portions: totalPortions,
      device_option: deviceValue,
      delivery_date: deliveryDate
    };

    const encodedCart = btoa(JSON.stringify(payload));

    window.location.href = `${window.ChinukiConfig.apiBaseUrl}/b2c/cart/?token=${encodedCart}`;
  } catch (err) {
    console.error('Error fetching cart:', err);
  }
});
